// extracted by mini-css-extract-plugin
module.exports = {"circularLoader":"CircularLoader_circularLoader__1ztMP","spin":"CircularLoader_spin__1Peka"};